export const MEMBER_CREATE_REQUEST = 'MEMBER_CREATE_REQUEST'
export const MEMBER_CREATE_SUCCESS = 'MEMBER_CREATE_SUCCESS'
export const MEMBER_CREATE_FAIL = 'MEMBER_CREATE_FAIL'
export const MEMBER_CREATE_MESSAGE_CLEAR = 'MEMBER_CREATE_MESSAGE_CLEAR'

export const MEMBER_UPDATE_REQUEST = 'MEMBER_UPDATE_REQUEST'
export const MEMBER_UPDATE_SUCCESS = 'MEMBER_UPDATE_SUCCESS'
export const MEMBER_UPDATE_FAIL = 'MEMBER_UPDATE_FAIL'
export const MEMBER_UPDATE_MESSAGE_CLEAR = 'MEMBER_UPDATE_MESSAGE_CLEAR'

export const MEMBER_DELETE_REQUEST = 'MEMBER_DELETE_REQUEST'
export const MEMBER_DELETE_SUCCESS = 'MEMBER_DELETE_SUCCESS'
export const MEMBER_DELETE_FAIL = 'MEMBER_DELETE_FAIL'
export const MEMBER_DELETE_MESSAGE_CLEAR = 'MEMBER_DELETE_MESSAGE_CLEAR'
